import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from "axios";

const Salvataggio = (props) => {

    useEffect(() => {
        console.log('useEffect Call_php_iniziale')
        if (props.aggiornamento) {
            chiamata_file_php_utente()
            props.SET_salva_dati(0)
        }
        // Good!
    }, [props.aggiornamento]);

    const chiamata_file_php_utente = () => {
        var dati_utente_aux = props.dati_utente
        dati_utente_aux.nome = 'renato'
        dati_utente_aux.cognome = 'zero'
        dati_utente_aux.file = props.lista_file_mp3
        dati_utente_aux.topic = props.lista_materie

        axios({
            method: "post",
            url: 'https://www.idroslab.com/react_walkmind/lista_file_salva.php',
            headers: { "content-type": "application/json" },
            data: dati_utente_aux
        }).then(data => {
            console.log('Salvataggio automatico file')
            console.log(data.data)
        }
        ).catch(err => {
            console.log('errore in axios')
            console.log(err)
            return null
        })
    };

    return (
        <div>
        </div>
    )
}
export default Salvataggio;



